import { render, staticRenderFns } from "./report-center.vue?vue&type=template&id=6219730a&scoped=true&"
import script from "./report-center.vue?vue&type=script&lang=js&"
export * from "./report-center.vue?vue&type=script&lang=js&"
import style0 from "./report-center.vue?vue&type=style&index=0&id=6219730a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219730a",
  null
  
)

export default component.exports